





































































































import Vue from 'vue'

import { ReturnBookingFragment } from '@/graphql-schema'

// interview report
import Report from '@/components/interviews/BasicReport.vue'
import Artifacts from '@/components/artifacts/Artifacts.tsx'
import { InterviewerEntersRoomTask } from '@/queries/tasks.graphql'
import { mapActions } from 'vuex'
import { VariablePayload } from '@/store/workflow/types'
import InterviewerEntersRoom from './InterviewerEntersRoom.vue'
import EnterLinkInReport from './EnterLinkInReport.vue'
import { TaskNodeFragment } from '@/graphql-schema'

export interface Data {
  taskForm: VariablePayload | null
  openModal: boolean
  linkClicked: boolean
}

export default Vue.extend({
  apollo: {
    tasks: {
      query: InterviewerEntersRoomTask,
      variables() {
        return {
          caseId: this.caseId,
          processInstanceId: this.selectedTask.processInstanceId,
        }
      },
    },
  },
  components: {
    Artifacts,
    Report,
    EnterLinkInReport,
  },
  created() {
    const interviewReports: any[] = this.$store.getters['interviewReports/filterBy'](this.where)
    this.$store.dispatch({ type: 'interview/bookings/fetch' })

    // load all interviewReports
    this.$store.dispatch({ type: 'interviewReports/pullObjects', setLoading: false }).then(data => {
      console.debug('loaded interview reports', data)
      const interviewReports: any[] = this.$store.getters['interviewReports/filterBy'](this.where)
      // create a letter, if none exists. this avoids jumping between the two editors.
      if (interviewReports.length === 0) {
        return this.$store.dispatch({
          type: 'interviewReports/pushObject',
          object: { ...this.defaults },
        })
      }
    })
  },
  data(): Data {
    return {
      taskForm: {},
      openModal: false,
      linkClicked: false,
    }
  },
  computed: {
    reports(): any[] {
      return this.$store.getters['interviewReports/filterBy'](this.where)
    },
    where(): object {
      return { case_id: this.caseId }
    },
    defaults(): object {
      return { ...this.where, interviewer_id: this.$store.getters.currentUserId }
    },
    clickTask(): TaskNodeFragment {
      if (
        this.tasks == undefined ||
        this.tasks == null ||
        this.tasks.nodes == null ||
        this.tasks.nodes.length == 0
      ) {
        return null
      } else {
        return this.tasks.nodes[0]
      }
    },
    clickTaskEnabled(): boolean {
      return this.clickTask != null && !this.linkClicked
    },
    asInterviewer(): ReturnBookingFragment[] {
      return (this.$store.getters[
        'interview/bookings/asInterviewer'
      ] as ReturnBookingFragment[]).filter(booking => booking!.offer!.id == this.offerId)
    },
  },
  methods: {
    ...mapActions('workflow', ['cancelProcess', 'startProcess', 'sendMessage']),
    async save(report) {
      try {
        const result = await this.$store.dispatch({
          type: 'interviewReports/pushObject',
          object: report,
        })
        console.log('result from action', result)
      } catch (error) {
        window.alert('Error Saving Interview-Report. Error is: ' + error)
      }
    },
    async connectionTimeout(report) {
      await this.save(report)
      await this.sendMessage({ messageName: `interrupted-interview-in-case-${this.caseId}` })
      //last but not least return to admin-Tasks
      this.$router.push({ name: 'admin.tasks' })
    },
    async interviewStartedManually(report, bookingId) {
      await this.save(report)
      await this.sendMessage({ messageName: `interview-started-manually-${bookingId}` })
      this.openModal = true
    },
    hideLinkSection() {
      this.linkClicked = true
    },
    getDiagnosis(report: {
      patient_accepted?: boolean
      patient_accepted_for_counseling?: boolean
      primary_problem_status_accepted?: string
    }): 'ptsd' | 'mde' | 'counseling' | 'excluded' | undefined {
      if (typeof report.patient_accepted === 'undefined') {
        return undefined
      } else if (!report.patient_accepted && !report.patient_accepted_for_counseling) {
        return 'excluded'
      } else if (report.primary_problem_status_accepted?.startsWith('PTSD Treatment')) {
        return 'ptsd'
      } else if (report.primary_problem_status_accepted?.startsWith('Depression Treatment')) {
        return 'mde'
      } else {
        return 'counseling'
      }
    },
  },
  props: {
    caseId: {
      type: String,
      required: true,
    },
    value: {
      required: true,
      type: Object,
    },
    locale: {
      type: String,
      default(): string {
        return this.$i18n.locale
      },
    },
    localVariables: {
      type: Object,
    },
    offerId: {
      type: String,
      required: true,
    },
    selectedTask: {
      type: Object,
      required: true,
    },
  },
})
